/* Per-viewer conveniences (units, chosen period). Storage can be unavailable; everything works without it. */
export const store = {
  get(k: string, d: string): string { try { const v = localStorage.getItem('mileposts.' + k); return v === null ? d : v; } catch { return d; } },
  set(k: string, v: string) { try { localStorage.setItem('mileposts.' + k, v); } catch { /* unavailable */ } },
};
